import React, { useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid, TextField, MenuItem, Select,InputLabel } from "@material-ui/core";
import { addUniqueCustomer } from "../../../actions/OffLineSupportActions"
import { connect } from "react-redux";
import moment from "moment";
import './index.sass'


interface Props {
    openAddMemberModal: boolean;
    setOpenAddMemberModal: Function;
    leadId: number;
    search: string;
    addUniqueCustomer: any;
    add_unique_customer:any

}

const Payment: React.FC<Props> = (props) => {
    const bookingInitialData = {
        bookingFor: "",
        designation: "",
        customerName: "",
        years: "",
        customerAgeInMonths: "",
        customerAgeInDays: "",
        dateOfBirth: "",
        patientGender: "",
    };

    const [bookingData, setBookingData] = useState<any>(bookingInitialData);

    const updateItemValue = (event: any) => {
        let tempBookingData = { ...bookingData };
        switch (event.name) {
            case "dateOfBirth":
                const a: any = moment();
                const b: any = moment(event.value);
                var years = a.diff(b, "year");
                b.add(years, "years");
                var months = a.diff(b, "months");
                b.add(months, "months");
                var days = a.diff(b, "days");
                tempBookingData["customerAgeInMonths"] = months;
                tempBookingData["customerAgeInDays"] = days;

                let today = new Date();
                let birthDate = new Date(event.value);
                let age = today.getUTCFullYear() - birthDate.getUTCFullYear();
                var m = today.getUTCMonth() - birthDate.getUTCMonth();
                if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
                    age--;
                }
                tempBookingData["years"] = age;
                tempBookingData[event.name] = event.value;
                break;
            case "designation":
                tempBookingData["patientGender"] =
                    event.value === "Mr" || event.value === "Master"
                        ? "male"
                        : event.value === "Ms" || event.value === "Mrs"
                            ? "female"
                            : "other";
                tempBookingData[event.name] = event.value;
                break;

            case "customerName":
                if (event.value.trim() === "") {
                    tempBookingData[event.name] = "";
                } else {
                    tempBookingData[event.name] = event.value
                        .replace(/[^a-zA-Z ]/g, "")
                        .replace(/\s\s+/g, " ");
                }
                break;
            default:
                tempBookingData[event.name] = event.value;
        }
        setBookingData(tempBookingData);
    };

    const submitForm = async (e: any) => {
        e.preventDefault();

        let payload = {
            // lead_id: props.leadId,
            first_name: bookingData?.customerName,
            customer_gender: bookingData?.patientGender,
            customer_age: bookingData?.years,
            dob: bookingData?.dateOfBirth,
            relation: bookingData?.bookingFor,
            designation: bookingData?.designation,
            mobile: props?.search
        };

        let newObj = {};
        for (const key in payload) {
            if (payload[key]) {
                newObj[key] = payload[key];
            }
        }

        await props.addUniqueCustomer(newObj);
        clearForm();
    };

    const clearForm = () => {
        setBookingData(bookingInitialData);
        props.setOpenAddMemberModal(false);
    };
    return (
        <>
            <DialogTitle id="addBookingMemberId">Add Booking Member</DialogTitle>
            <DialogContent style={{ padding: "10px" }}>
                <form onSubmit={submitForm} >
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={12}>
                        <InputLabel htmlFor="Designation">Designation</InputLabel>
                            <Select
                                fullWidth
                                id="designation"
                                name="designation"
                                className="input"
                                label="Designation"
                                variant="outlined"
                                style={{height:"39px"}}
                                value={bookingData?.designation}
                                onChange={(e) => updateItemValue(e.target)}
                                required
                            >
                                <MenuItem value="Mr">Mr</MenuItem>
                                <MenuItem value="Mrs">Mrs</MenuItem>
                                <MenuItem value="Ms">Ms</MenuItem>
                                <MenuItem value="Dr">Dr</MenuItem>
                                <MenuItem value="Master">Master</MenuItem>
                                <MenuItem value="Baby">Baby</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item md={3} xs={12}>
                        <InputLabel htmlFor="Customer Name">Customer Name</InputLabel>
                            <TextField
                                fullWidth
                                id="customerName"
                                name="customerName"
                                className="input"
                                variant="outlined"
                                value={bookingData?.customerName}
                                onChange={(e) => updateItemValue(e.target)}
                                required
                            />
                        </Grid>
                        <Grid item md={1} xs={12}>
                        <InputLabel htmlFor="Years">Years</InputLabel>
                            <TextField
                                fullWidth
                                id="years"
                                name="years"
                                type="number"
                                className="input"
                                disabled={bookingData?.dateOfBirth !== ""}
                                placeholder="Enter Age"
                                variant="outlined"
                                InputProps={{
                                    inputProps: {
                                        min: bookingData?.dateOfBirth ? 0 : 1,
                                        max: 99,
                                    },
                                }}
                                value={bookingData?.years}
                                onChange={(e) =>
                                    Number(e.target.value) > 99 ? "" : updateItemValue(e.target)
                                }
                                required
                            />
                        </Grid>
                        <Grid item md={1} xs={12}>
                        <InputLabel htmlFor="Months">Months</InputLabel>
                            <TextField
                                id="customerAgeInMonths"
                                name="customerAgeInMonths"
                                type="number"
                                className="input"
                                disabled
                                value={bookingData?.customerAgeInMonths}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item md={1} xs={12}>
                        <InputLabel htmlFor="Days">Days</InputLabel>
                            <TextField
                                id="customerAgeInDays"
                                name="customerAgeInDays"
                                type="number"
                                className="input"
                                disabled
                                value={bookingData?.customerAgeInDays}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item md={3} xs={12}>
                        <InputLabel htmlFor="Date of Birth">Date of Birth</InputLabel>
                            <TextField
                                id="dateOfBirth"
                                name="dateOfBirth"
                                type="date"
                                variant="outlined"
                                className="input"
                                required={bookingData?.years === ""}
                                value={bookingData?.dateOfBirth}
                                onChange={(e) => updateItemValue(e.target)}
                                fullWidth
                                inputProps={{
                                    max: moment().subtract(1, "days").format("YYYY-MM-DD"),
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item md={3} xs={12}>
                        <InputLabel htmlFor="Gender">Gender</InputLabel>
                            <Select
                                fullWidth
                                id="patientGender"
                                name="patientGender"
                                label="Gender"
                                variant="outlined"
                                className="input"
                                value={bookingData?.patientGender}
                                onChange={(e) => updateItemValue(e.target)}
                                required
                                style={{height:"39px"}}
                                disabled={
                                    bookingData?.designation === "Mr" ||
                                    bookingData?.designation === "Mrs" ||
                                    bookingData?.designation === "Ms"
                                }
                            >
                                <MenuItem value={"male"}>Male</MenuItem>
                                <MenuItem value={"female"}>Female</MenuItem>
                                <MenuItem value={"other"}>Other</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item md={3} xs={12}>
                        <InputLabel htmlFor="Booking For">Booking For</InputLabel>
                            <Select
                                fullWidth
                                id="bookingFor"
                                name="bookingFor"
                                variant="outlined"
                                className="input"
                                value={bookingData?.bookingFor}
                                onChange={(e) => updateItemValue(e.target)}
                                style={{height:"39px"}}
                                required
                            >
                                <MenuItem value="self">Self</MenuItem>
                                <MenuItem value="spouse">Spouse</MenuItem>
                                <MenuItem value="mother">Mother</MenuItem>
                                <MenuItem value="father">Father</MenuItem>
                                <MenuItem value="daughter">Daughter</MenuItem>
                                <MenuItem value="son">Son</MenuItem>
                                <MenuItem value="grandparents">Grandparents</MenuItem>
                                <MenuItem value="siblings">Siblings</MenuItem>
                                <MenuItem value="in-laws">In-laws</MenuItem>
                                <MenuItem value="other">Others</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                type="submit"
                                style={{marginTop:"26px"}}
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                onClick={clearForm}
                                style={{marginTop:"26px"}}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions></DialogActions>
        </>
    );
};
const mapStateToProps = (state: any) => ({
    add_unique_customer: state.OffLineSupporteReducer.add_unique_customer,
});

export default connect(mapStateToProps, {
    addUniqueCustomer
})(Payment);
